import React, {PropTypes} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import toastr from "toastr";
import * as actions from "../../../redux/actions/Authentication/authActions";


//Errors component. Used to display errors. currently using toastr, can be used to display on screen messages as well
class Errors extends React.Component {

  constructor() {
    super();
  }

  componentDidMount() {
  }

  componentWillReceiveProps(props) {
    if (props.Errors[0].errors[0].errorMessage != "NoError") {
      props.Errors[0].errors.map((error)=> {
        setTimeout(()=> {

          if (error.errorMessage) {
            if (error.errorCode == 'SERVER_DOWN') {
              toastr.warning(error.errorMessage);
            }
            else
              toastr.error(error.errorMessage);
          }

          else if (error.message) {
            if (error.code == "INVALID_SESSION_ID") {
              //Logout -> invalid session id found, reset the cookie and go back to login page
              if (this.props.loggedIn[0].loggedIn == false) {
                toastr.error(error.message);
              }
              this.props.actions.logOut();

            }

            else toastr.error(error.message);
          }

        }, 500);
      });
    }
  }

  render() {
    return (<div></div>
    );
  }


}

Errors.propTypes = {
  Errors: React.PropTypes.array,
  actions: React.PropTypes.object.isRequired
};
Errors.defaultProps = {
  Errors: []
};

function mapStateToProps(state, ownState) {

  return {
    Errors: state.error,
    loggedIn: state.auth

  };

}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };

}

export default connect(mapStateToProps, mapDispatchToProps)(Errors);




/** WEBPACK FOOTER **
 ** ./src/components/common/utils/Errors.js
 **/